'use strict';

// https://en.wikipedia.org/wiki/List_of_ISO_3166_country_codes
export const MATCH_GROUP = {
  GLOBAL: 'GLOBAL', // For "global". This code is not in ISO 3166.
  KR: 'KR',
  TW: 'TW',
};
